// paste your presets here

export default [
  {
    name: "PLUCK - Take Me Away",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0.49999999999999994,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 1,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0.10000000000000002,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 1,
      M_ROW_1: [1, 3, 0.3400000000000001],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 2.06,
      LFO_1_GAIN: 0.6416666666666665,
      FX3_2: 0.5499999999999999,
      LFO_1_FC: 7.468333333333335,
      FX3_1: 0.42208333333333314,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.4310499224892786,
      FX2_4: 0,
      EG_1_SUS: 0.6333333333333333,
      FX2_3: 0,
      EG_1_DEC: 2.1099531249999997,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 0,
      AMP_EG_REL: 1.18054156419224,
      FX1_2: 0,
      AMP_EG_SUS: 0,
      FX1_1: 0,
      AMP_EG_DEC: 5,
      AMP_EG_ATT: 0.001,
      FILTER_EG: 0.5000000000000001,
      FILTER_TP: 0,
      FILTER_Q: 0,
      FILTER_CUT: 20,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 0,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 0,
      OSC_2_VOICE: 0,
      OSC_1_RETR: 1,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 0,
      OSC_1_SPRD: 0,
      OSC_1_VOICE: 2
    }
  },
  {
    name: "KEY - Thunk",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0.6999999999999997,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 1,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0.07499999999999998,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0.49999999999999994,
      LFO_2_RETR: 0,
      FX2_ON: 1,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0.03837500000000003,
      LFO_1_PHASE: 0,
      FX4_1: 1.855833333333334,
      LFO_1_GAIN: 0,
      FX3_2: 0.058333333333333265,
      LFO_1_FC: 0,
      FX3_1: 0.34291666666666654,
      LFO_1_TP: 0,
      FX2_5: 180,
      EG_1_REL: 0.00482288873558031,
      FX2_4: 0.7600000000000001,
      EG_1_SUS: 0,
      FX2_3: 0.49999999999999994,
      EG_1_DEC: 1.0569469826576017,
      FX2_2: 0.39999999999999997,
      EG_1_ATT: 0.017871625000000328,
      FX2_1: 8.300000000000008,
      AMP_EG_REL: 1.4906606294089104,
      FX1_2: 0,
      AMP_EG_SUS: 0.20833333333333331,
      FX1_1: 0,
      AMP_EG_DEC: 2.1081006798783886,
      AMP_EG_ATT: 0.017871625000000006,
      FILTER_EG: 0.5916666666666669,
      FILTER_TP: 0,
      FILTER_Q: 10,
      FILTER_CUT: 164.61213513549072,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 1,
      OSC_2_TP: 3,
      OSC_2_PHASE: 83,
      OSC_2_FINE: 9,
      OSC_2_SEMI: 0,
      OSC_2_OCT: -1,
      OSC_2_SPRD: 15,
      OSC_2_VOICE: 4,
      OSC_1_RETR: 1,
      OSC_1_TP: 3,
      OSC_1_PHASE: 44,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: -1,
      OSC_1_SPRD: 20,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "LD - Fatness",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.2469895634982042,
      FX2_4: 0,
      EG_1_SUS: 0,
      FX2_3: 0,
      EG_1_DEC: 7.6851953930949835,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 0,
      AMP_EG_REL: 0.25,
      FX1_2: 0,
      AMP_EG_SUS: 0.8250000000000001,
      FX1_1: 0,
      AMP_EG_DEC: 0.6191623993535121,
      AMP_EG_ATT: 0.02,
      FILTER_EG: 0.38333333333333325,
      FILTER_TP: 1,
      FILTER_Q: 4.1666666666666705,
      FILTER_CUT: 223.22250000000173,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 1,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 1,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 40,
      OSC_2_VOICE: 2,
      OSC_1_RETR: 0,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: -1,
      OSC_1_SPRD: 40,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "HOV - Rave",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [4, 15, 0.56],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.7470974238530165,
      FX2_4: 0.1,
      EG_1_SUS: 0,
      FX2_3: 1.3877787807814457e-17,
      EG_1_DEC: 5.4085159937541505,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 2,
      AMP_EG_REL: 0.25,
      FX1_2: 0,
      AMP_EG_SUS: 1,
      FX1_1: 0,
      AMP_EG_DEC: 0.001,
      AMP_EG_ATT: 0.001,
      FILTER_EG: 0.7000000000000001,
      FILTER_TP: 0,
      FILTER_Q: 3.5,
      FILTER_CUT: 6682.142178319935,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 1,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 1,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: -1,
      OSC_2_SPRD: 63,
      OSC_2_VOICE: 4,
      OSC_1_RETR: 0,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 10,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 0,
      OSC_1_SPRD: 60,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "KEY - Square",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.2000000000000003,
      FX2_4: 0,
      EG_1_SUS: 0,
      FX2_3: 0,
      EG_1_DEC: 0.3127247629224269,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 0,
      AMP_EG_REL: 3.314710866938475,
      FX1_2: 0,
      AMP_EG_SUS: 0.8000000000000003,
      FX1_1: 0,
      AMP_EG_DEC: 0.2,
      AMP_EG_ATT: 0.03474662500000002,
      FILTER_EG: 0.3,
      FILTER_TP: 1,
      FILTER_Q: 2,
      FILTER_CUT: 364.45843750000125,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 1,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 3,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 1,
      OSC_2_SPRD: 10,
      OSC_2_VOICE: 4,
      OSC_1_RETR: 0,
      OSC_1_TP: 3,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 2,
      OSC_1_SPRD: 25,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "KEY - Pluck",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0.05000000000000002,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 1,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0.4999999999999996,
      LFO_2_RETR: 0,
      FX2_ON: 1,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0,
      FX3_2: 0.5166666666666666,
      LFO_1_FC: 0,
      FX3_1: 0.2875,
      LFO_1_TP: 0,
      FX2_5: 139.5,
      EG_1_REL: 3.7486419440158243,
      FX2_4: 0.1825,
      EG_1_SUS: 0,
      FX2_3: 0.2,
      EG_1_DEC: 0.31272476292242674,
      FX2_2: 0.7000000000000001,
      EG_1_ATT: 0.001,
      FX2_1: 6.800000000000013,
      AMP_EG_REL: 1.5932277612737327,
      FX1_2: 0,
      AMP_EG_SUS: 0.35000000000000003,
      FX1_1: 0,
      AMP_EG_DEC: 0.2,
      AMP_EG_ATT: 0.001,
      FILTER_EG: 0.7333333333333333,
      FILTER_TP: 1,
      FILTER_Q: 0,
      FILTER_CUT: 205.3052542682495,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 0,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 0,
      OSC_2_VOICE: 0,
      OSC_1_RETR: 1,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 0,
      OSC_1_SPRD: 0,
      OSC_1_VOICE: 2
    }
  },
  {
    name: "KEY - Woop",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0.44999999999999996,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 1,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [4, 15, -0.54],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0.18462337500000026,
      LFO_1_PHASE: 0,
      FX4_1: 2.305,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.2,
      FX2_4: 0,
      EG_1_SUS: 0,
      FX2_3: 0,
      EG_1_DEC: 0.39306543194698784,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 0,
      AMP_EG_REL: 0.4010509774379971,
      FX1_2: 0,
      AMP_EG_SUS: 1,
      FX1_1: 0,
      AMP_EG_DEC: 0.0010925694722118805,
      AMP_EG_ATT: 0.02,
      FILTER_EG: 0,
      FILTER_TP: 6,
      FILTER_Q: 0,
      FILTER_CUT: 10000,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0.9,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 1,
      OSC_2_TP: 0,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 1,
      OSC_2_SPRD: 0,
      OSC_2_VOICE: 1,
      OSC_1_RETR: 1,
      OSC_1_TP: 0,
      OSC_1_PHASE: 181,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 0,
      OSC_1_SPRD: 0,
      OSC_1_VOICE: 1
    }
  },
  {
    name: "LD - Bowwoo",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [1, 13, 0.72],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0.6000000000000001,
      LFO_2_GAIN: 0,
      FX1_ON: 1,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0.975,
      FX3_2: 0,
      LFO_1_FC: 1.506666666666667,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.2,
      FX2_4: 0,
      EG_1_SUS: 0.5,
      FX2_3: 0,
      EG_1_DEC: 0.1,
      FX2_2: 0,
      EG_1_ATT: 0.001,
      FX2_1: 0,
      AMP_EG_REL: 0.25,
      FX1_2: 0.7750000000000001,
      AMP_EG_SUS: 0.45,
      FX1_1: 3,
      AMP_EG_DEC: 1.4150469420618368,
      AMP_EG_ATT: 0.02,
      FILTER_EG: 0,
      FILTER_TP: 3,
      FILTER_Q: 1.7500000000000024,
      FILTER_CUT: 20,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0.18333333333333335,
      OSC_2_VOL: 1,
      OSC_1_PAN: -0.16666666666666685,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 1,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: -1,
      OSC_2_SPRD: 40,
      OSC_2_VOICE: 2,
      OSC_1_RETR: 0,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: -1,
      OSC_1_SPRD: 38,
      OSC_1_VOICE: 2
    }
  },
  {
    name: "PD - Deep",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 1,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 1,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0.20833333333333331,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0.3450000000000002,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0.2,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 88.50000000000003,
      EG_1_REL: 0.2,
      FX2_4: 0.34750000000000136,
      EG_1_SUS: 0.35000000000000003,
      FX2_3: 0.22499999999999995,
      EG_1_DEC: 0.1,
      FX2_2: 0.2666666666666667,
      EG_1_ATT: 2.1607840000000023,
      FX2_1: 2.75,
      AMP_EG_REL: 1.5932277612737327,
      FX1_2: 0,
      AMP_EG_SUS: 0.5,
      FX1_1: 0,
      AMP_EG_DEC: 0.0010925694722118814,
      AMP_EG_ATT: 2.4288326442918966,
      FILTER_EG: 0.15833333333333327,
      FILTER_TP: 0,
      FILTER_Q: 1.5000000000000002,
      FILTER_CUT: 223.22249999999931,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0.9,
      OSC_2_PAN: 0.18333333333333357,
      OSC_2_VOL: 1,
      OSC_1_PAN: -0.16666666666666707,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 1,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 40,
      OSC_2_VOICE: 4,
      OSC_1_RETR: 0,
      OSC_1_TP: 1,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 1,
      OSC_1_SPRD: 40,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "PD - Low",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.25000000000000006,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0,
      M_ROW_2: [0, 0, 0],
      FX3_ON: 0,
      M_ROW_1: [0, 0, 0],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0,
      FX3_2: 0,
      LFO_1_FC: 0,
      FX3_1: 0,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 2.395563782116108,
      FX2_4: 0,
      EG_1_SUS: 0,
      FX2_3: 0,
      EG_1_DEC: 3.7809470829529648,
      FX2_2: 0,
      EG_1_ATT: 2.072037088541667,
      FX2_1: 0,
      AMP_EG_REL: 1.5932277612737338,
      FX1_2: 0,
      AMP_EG_SUS: 1,
      FX1_1: 0,
      AMP_EG_DEC: 0.2,
      AMP_EG_ATT: 0.762421230237385,
      FILTER_EG: 0.41666666666666696,
      FILTER_TP: 1,
      FILTER_Q: 1.9166666666666647,
      FILTER_CUT: 51.72750000000036,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0.9,
      OSC_1_PAN: 0,
      OSC_1_VOL: 0.95,
      OSC_2_RETR: 0,
      OSC_2_TP: 2,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 47,
      OSC_2_VOICE: 4,
      OSC_1_RETR: 0,
      OSC_1_TP: 3,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 20,
      OSC_1_SEMI: 0,
      OSC_1_OCT: -1,
      OSC_1_SPRD: 35,
      OSC_1_VOICE: 4
    }
  },
  {
    name: "PD - SunRise",
    values: {
      M_ROW_5: [0, 0, 0],
      FX4_WET: 0,
      MASTER_GAIN: 0.5,
      M_ROW_4: [0, 0, 0],
      FX4_ON: 0,
      M_ROW_3: [0, 0, 0],
      FX3_WET: 0.25,
      M_ROW_2: [1, 13, 0.21999999999999997],
      FX3_ON: 1,
      M_ROW_1: [1, 3, 0.10000000000000009],
      FX2_WET: 0,
      LFO_2_RETR: 0,
      FX2_ON: 0,
      LFO_2_PHASE: 0,
      FX1_WET: 0,
      LFO_2_GAIN: 0,
      FX1_ON: 0,
      LFO_2_FC: 0,
      FX5_ON: 0,
      LFO_2_TP: 0,
      FX5_1: 0,
      LFO_1_RETR: 0,
      FX4_2: 0,
      LFO_1_PHASE: 0,
      FX4_1: 0,
      LFO_1_GAIN: 0.15000000000000002,
      FX3_2: 0.3,
      LFO_1_FC: 5.835000000000001,
      FX3_1: 0.24,
      LFO_1_TP: 0,
      FX2_5: 0,
      EG_1_REL: 0.13522964304099497,
      FX2_4: 0,
      EG_1_SUS: 0,
      FX2_3: 0,
      EG_1_DEC: 0.2657784023602666,
      FX2_2: 0,
      EG_1_ATT: 0.9121588750000083,
      FX2_1: 0,
      AMP_EG_REL: 0.4010509774379971,
      FX1_2: 0,
      AMP_EG_SUS: 0,
      FX1_1: 0,
      AMP_EG_DEC: 0.03474662500000002,
      AMP_EG_ATT: 1.1220401080586275,
      FILTER_EG: 0.8500000000000001,
      FILTER_TP: 1,
      FILTER_Q: 3.9999999999999996,
      FILTER_CUT: 332.1875000000004,
      OSC_3_PAN: 0,
      OSC_3_VOL: 0,
      OSC_2_PAN: 0,
      OSC_2_VOL: 0,
      OSC_1_PAN: 0,
      OSC_1_VOL: 1,
      OSC_2_RETR: 0,
      OSC_2_TP: 0,
      OSC_2_PHASE: 0,
      OSC_2_FINE: 0,
      OSC_2_SEMI: 0,
      OSC_2_OCT: 0,
      OSC_2_SPRD: 0,
      OSC_2_VOICE: 0,
      OSC_1_RETR: 1,
      OSC_1_TP: 3,
      OSC_1_PHASE: 0,
      OSC_1_FINE: 0,
      OSC_1_SEMI: 0,
      OSC_1_OCT: 1,
      OSC_1_SPRD: 12,
      OSC_1_VOICE: 2
    }
  }
];
